module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "custom-app-event",
    class: {
      'custom-app-event--family-fun-event': _vm.$route.path.includes('/mouth-guard-registration'), 'custom-app-event--banner': _vm.$route.path !== '/mouth-guard-registration'
    },
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.event.bg_img + ')'
    })
  }, [(_vm.$route.path.includes("/mouth-guard-registration")) ? _c('div', {
    staticClass: "custom-app-event__container",
    class: {
      'custom-app-event__container--family-fun-event': _vm.$route.path.includes('/mouth-guard-registration')
    }
  }, [_c('div', {
    staticClass: "custom-app-event__inner"
  }, [_c('div', {
    staticClass: "custom-app-event__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.event.title)
    }
  }), _c('div', {
    staticClass: "custom-app-event__subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.event.subtitle)
    }
  }), _c('div', {
    staticClass: "custom-app-event__content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.event.content)
    }
  }), _c('div', {
    staticClass: "custom-app-event__btn",
    on: {
      "click": function($event) {
        return _vm.openModal(4)
      }
    }
  }, [_vm._v("Register Today")]), _c('h3', {
    staticStyle: {
      "color": "white",
      "margin-top": "20px"
    }
  }, [_vm._v("Please also print this Permission and Release Form and bring with you to the date and time you registered for")]), _c('a', {
    staticClass: "custom-app-event__btn",
    attrs: {
      "target": "_blank",
      "href": "/wp-content/uploads/Mouth-Guard-Permission-and-Release-2023.pdf"
    }
  }, [_vm._v("Permission and Release Form")])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba4df8da","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-app-event/custom-app-event.pug
// module id = 732
// module chunks = 1